module.exports = __webpack_public_path__ + "img/EMS_user_manual35.2bd977d3.png";